import {lazy} from 'react';

export const ApiPoweredContainerLazy = lazy(() => import(/* webpackChunkName: "apiPoweredContainer" */ '.'));
